import styled from "styled-components"

const MenuCard = styled.div`
  padding-left: .5rem;
  padding-right: .5rem;
  cursor: pointer;
  min-height: 2.5rem;
  display: flex;
  align-items: center;
`

export default MenuCard